import React from "react";
import ButtonConfigurationCard from "./ButtonConfigurationCard";
import Stack from "@mui/material/Stack";

const ButtonConfiguration: React.FC = () => {
    return (
      <React.Fragment>
        <Stack spacing={2} width="100%" alignItems="center" p={0.3}>
          <ButtonConfigurationCard />
        </Stack>
      </React.Fragment>
    );
};

export default ButtonConfiguration;
